export type CaptureLinkRow = {
  id: string;
  processTitle?: string;
  productProcessId?: string;
  status?: string;
  expiresAt?: string;
  remainingUploads?: number;
  maxUploads?: number;
  usedCount?: number;
  path?: string;
  token?: string;
};

const titleOf = (value?: string) => String(value || "").trim().toLowerCase();

export const linksForProcess = (
  links: CaptureLinkRow[],
  savedProcessId: string,
  processTitle: string
): CaptureLinkRow[] => {
  const id = String(savedProcessId || "").trim();
  const want = titleOf(processTitle);
  return links
    .filter((row) => {
      const rowId = String(row.productProcessId || "").trim();
      if (id) {
        if (rowId) {
          return rowId === id;
        }
        return want !== "" && titleOf(row.processTitle) === want;
      }
      return want !== "" && titleOf(row.processTitle) === want;
    })
    .slice()
    .sort((a, b) => {
      if (a.status === "OPEN" && b.status !== "OPEN") return -1;
      if (a.status !== "OPEN" && b.status === "OPEN") return 1;
      return 0;
    });
};

export const createCaptureLinkBody = (input: {
  productId: string;
  processTitle: string;
  processIndex?: number;
  productProcessId?: string;
  instruction?: string;
  allowedKinds: Array<"PHOTO" | "VIDEO">;
  expiryHours: number;
  /** Optional: the server WhatsApps the link to this phone (when WhatsApp is on). */
  recipientPhone?: string;
}) => ({
  productId: input.productId,
  processTitle: input.processTitle,
  processIndex: Number.isInteger(input.processIndex) ? input.processIndex : undefined,
  productProcessId: String(input.productProcessId || "").trim() || undefined,
  instruction: input.instruction,
  allowedKinds: input.allowedKinds,
  expiryHours: input.expiryHours,
  maxUploads: 4,
  recipientPhone: String(input.recipientPhone || "").trim() || undefined,
});
